export default __webpack_public_path__ + "static/media/roteador.dd8cb825.png";